module.exports = __webpack_public_path__ + "files/ed5c6414e8795741a1418e4772629e00.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/custom-1.png
// module id = 1157
// module chunks = 76